import React, { useState } from "react";
import DataGrid from "../components/DataGrid/DataGrid"; // Assume DataGrid is in the same directory
import { Add, Delete, Edit, Language, Visibility, Web } from "@mui/icons-material";
import RowContextMenu from "../components/DataGrid/RowContextMenu";
import { useNavigate } from "react-router-dom";
import StoreEditor from "./StoreEditor";
import DetailDialog from "../components/DetailDialog/DetailDialog";
import { Box } from "@mui/material";

const renderLinkCell = (row) => {
  return row.sellsabeel_domain ? (
    <a href={row.sellsabeel_domain} target="_blank" rel="noreferrer">
      <Language
      color="primary"
      style={{cursor:'pointer'}}
    />
    </a>
  ) : null; // Return null if no sellsabeel_domain
};

function formatDate(isoString) {
  const date = new Date(isoString);

  if (isNaN(date)) {
    return "/";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const Main = () => {
   const [openEditor, setOpenEditor] = useState(false);
  const [current, setCurrent] = useState(null);
  const navigate = useNavigate();

  const columns = [
    { field: "id", headerName: "ID", align: "left", filterable: true, size: '80px', hiddenFilterOptions: true },
    { field: "name", headerName: "Name", align: "left", filterable: true, permanent: true },
    { field: "sellsabeel_domain", headerName: "Domain", align: "center", filterable: true,
      render: (row) => renderLinkCell(row)
     },
    { field: "createdAt", headerName: "Creation", align: "left", filterable: true, type: "date",
      render: (row) => formatDate(row.createdAt)
     },
    { field: "updatedAt", headerName: "Last Update", align: "left", filterable: true, type: "date",
      render: (row) => formatDate(row.updatedAt)
     },];

  // Define actions outside the RowContextMenu
  /*const rowActions = [
      { name: "View", icon: <Visibility color="primary" fontSize="small" />, onClick: (row) => navigate(`/partner-info/${row.id}`) },
      { name: "Edit", icon: <Edit fontSize="small" />, onClick: (row) => console.log("Editing row:", row) },
      { name: "Delete", icon: <Delete fontSize="small" style={{ color: 'red' }} />,  onClick: (row) => console.log("Deleting row:", row)},
  ];*/
  const rowActions = [
    { name: "View", icon: <Visibility color="primary" fontSize="small" />, onClick: (row) => navigate(`/partner-info/${row.id}`) },
];

const headerActions = [
            { name: "Add", icon: <Add fontSize="small" color='secondary' />, onClick: () => {setCurrent({id:0}); setOpenEditor(true)} },
        ];

const CustomRowContextMenu = (props) => {
    return <RowContextMenu {...props} actions={rowActions} />
}

  return (
    <div>
      <h1>Stores</h1>
      <DataGrid table={'stores'} columns={columns} endPoint="/api/partner/store"
        headerActions={headerActions}
        RowContextMenu={CustomRowContextMenu} exportFileName='Stores' />
      <DetailDialog 
          open={openEditor} 
          title={"Store Editor"}
          onClose={()=>setOpenEditor(false)} 
          fullScreen={false}>
            <Box sx={{p:2}}>
                <StoreEditor data={current} onChange={()=>setOpenEditor(false)} onCancel={()=>setOpenEditor(false)} />
            </Box>
        </DetailDialog>
    </div>
  );
};

export default Main;
